import { adminRouteAlias, getAdminNavigationPath } from '../../router/adminRouteAlias'

export const pages = [
    { path: getAdminNavigationPath(adminRouteAlias.parts.location), label: 'Запчасти', countKey: 'itemsTotal' },
    { path: getAdminNavigationPath(adminRouteAlias.draftsOfParts.location), label: 'Черновики', countKey: 'draftCount' },
    { path: getAdminNavigationPath(adminRouteAlias.archivedParts.location), label: 'Архив', countKey: 'archivedCount' },
    { path: getAdminNavigationPath(adminRouteAlias.soldParts.location), label: 'Продажи', countKey: 'soldCount' },
]
